import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      <div className="services-hero">
        <div className="container">
          <h1>Our Construction Services</h1>
          <p>Quality craftsmanship, every project</p>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          {/* All Services Grid */}
          <section className="all-services">
            <h2>Our Complete Service Portfolio</h2>
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon">🏠</div>
                <h3>Home Renovation</h3>
                <p>Complete home transformations and improvements to enhance your living space.</p>
                <Link to="/book-appointment?service=Home Renovation" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🚿</div>
                <h3>Bathroom Remodeling</h3>
                <p>Modern bathroom designs and renovations to create your dream space.</p>
                <Link to="/book-appointment?service=Bathroom Remodeling" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🏠</div>
                <h3>Roofing</h3>
                <p>Professional roofing installation, repair, and maintenance services.</p>
                <Link to="/book-appointment?service=Roofing" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🪵</div>
                <h3>Flooring</h3>
                <p>High-quality flooring installation including hardwood, tile, and carpet.</p>
                <Link to="/book-appointment?service=Flooring" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🧱</div>
                <h3>Sheetrock</h3>
                <p>Professional drywall installation, repair, and finishing services.</p>
                <Link to="/book-appointment?service=Sheetrock" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🎨</div>
                <h3>Paint</h3>
                <p>Interior and exterior painting services with premium quality finishes.</p>
                <Link to="/book-appointment?service=Paint" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🏘️</div>
                <h3>Siding</h3>
                <p>Expert siding installation and repair to protect and beautify your home.</p>
                <Link to="/book-appointment?service=Siding" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🔨</div>
                <h3>Carpentry</h3>
                <p>Custom carpentry work including cabinets, trim, and built-ins.</p>
                <Link to="/book-appointment?service=Carpentry" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🧱</div>
                <h3>Masonry</h3>
                <p>Professional masonry work including brick, stone, and concrete projects.</p>
                <Link to="/book-appointment?service=Masonry" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🪑</div>
                <h3>Furniture Assembly</h3>
                <p>Professional furniture assembly and setup services for your home.</p>
                <Link to="/book-appointment?service=Furniture Assembly" className="book-button">Book an appointment</Link>
              </div>
              <div className="service-card">
                <div className="service-icon">🗑️</div>
                <h3>Junk Removal</h3>
                <p>Complete junk removal and debris cleanup services for your property.</p>
                <Link to="/book-appointment?service=Junk Removal" className="book-button">Book an appointment</Link>
              </div>
            </div>
          </section>


          {/* Process Section */}
          <section className="process-section">
            <h2>Our Construction Process</h2>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <h3>Initial Consultation</h3>
                <p>We meet with you to understand your vision, requirements, and budget for the project.</p>
              </div>
              <div className="process-step">
                <div className="step-number">2</div>
                <h3>Design & Planning</h3>
                <p>Our team creates detailed plans and designs, ensuring every aspect is carefully considered.</p>
              </div>
              <div className="process-step">
                <div className="step-number">3</div>
                <h3>Permits & Approvals</h3>
                <p>We handle all necessary permits and regulatory approvals to ensure compliance.</p>
              </div>
              <div className="process-step">
                <div className="step-number">4</div>
                <h3>Construction</h3>
                <p>Our skilled craftsmen bring your project to life with quality materials and expert workmanship.</p>
              </div>
              <div className="process-step">
                <div className="step-number">5</div>
                <h3>Final Inspection</h3>
                <p>Thorough quality checks and final inspections ensure everything meets our high standards.</p>
              </div>
              <div className="process-step">
                <div className="step-number">6</div>
                <h3>Project Delivery</h3>
                <p>We hand over your completed project with all documentation and ongoing support information.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Services;
